<template>
  <div v-if="getSearchedName.length <= 0" class="simple-element" style="word-break: break-word;" v-html="getElementName" />
  <q-item-label v-else class="simple-element" style="word-break: break-word;">
    <span v-for="(span, i) in getSearchedName" :key="i" :style="span.style" v-html="span.text" />
  </q-item-label>
</template>
  
<script lang="ts">
  import { VariableType } from '@/models/etc/types';
  import _ from 'lodash';
  import { date } from 'quasar';
  import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { tokenizeSearch, buildHighlightSpans } from '@/components/common/basic/search-highlight/searchHighlight';

  @Component({
    name: 'SimpleElement'
  })
  export default class SimpleElement extends Vue {
      @Prop({ default: VariableType.String })
      elementType!: VariableType
      @Prop({ default: undefined })
      element!: any
      @Prop({ default: '' })
      filter_string?: string
      @Prop({ default: false })
      truncateName!: boolean
  
      created() {
          //
      }

      get resolvedName(): string {
        if (!this.element) return '';
        if (this.truncateName) return this.element.Name;
        // FullName есть только у тегов (TagWithFrequency); у остальных наследников CommonEntity отображаем Name.
        if (this.element.FullName) return this.element.FullName;
        return this.element.Name;
      }

      get getSearchedName(): Array<{ text: string; style: string }> {
        if (!this.filter_string?.trim()) return [];
        const tokens = tokenizeSearch(this.filter_string);
        if (!tokens.length) return [];
        return buildHighlightSpans(this.resolvedName, tokens);
      }
  
      get getElementName(): string {
        if (!this.element) { return '' }
        switch(this.elementType) {
          case VariableType.Entity:
          case VariableType.AddressInline:
            return this.resolvedName
          case VariableType.Date:
            return date.formatDate(new Date(""+this.element), 'DD.MM.YYYY')
          case VariableType.DateTime:
            return date.formatDate(new Date(""+this.element), 'DD.MM.YYYY HH:mm:ss')
          case VariableType.Boolean:
            return this.element ? this.$t('yes_label') : this.$t('no_label')
          case VariableType.Number:
          case VariableType.String:
            return ""+this.element
          default:
            // Объект — это всегда наследник CommonEntity с полем Name; стрингификации объекта
            // (которая давала [object Object]) тут быть не должно. Примитивы отдаём как есть.
            return typeof this.element === 'object' ? this.resolvedName : ""+this.element
        }
      }
  
      @Watch('element', { deep: true })
      updateItems() {
          // remember state
          // @ts-ignore
      }
  }
  </script>
  
  <style lang="scss">
  .simple-element {
    color: var(--Text-color-text_main, #4D4D4D);
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding: 0 $h-padding;
    border-radius: $smaller-radius;
  }
  </style>